import { Icon } from '@livable/saas-react-components';
import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import useStyles from '../styles';
const iconExample = "\nimport { Icon } from '@livable/saas-react-components'";
export default function LvIconsState() {
  const classes = useStyles();
  const colors = ['error', 'success', 'success-bold', 'grey', 'info', 'warning'];
  const patterns = ['gradient', 'gradient-inside-square', 'gradient-square', 'error', 'success', 'white'];
  const states = ['error', 'success', 'primary', 'info', 'warning', 'dark', 'grey', 'lightGrey'];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, /*#__PURE__*/React.createElement("span", null, "Icons state")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, iconExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h3",
    gutterBottom: true
  }, "Patterns"), /*#__PURE__*/React.createElement("div", {
    className: classes.iconsWrapper
  }, patterns.map(pattern => /*#__PURE__*/React.createElement("div", {
    className: classes.iconStateWrapper,
    key: pattern
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    pattern: pattern,
    type: "coin"
  }), /*#__PURE__*/React.createElement("pre", {
    className: "".concat(classes.codeSnippet, " ").concat(classes.codeSnippetInline)
  }, /*#__PURE__*/React.createElement("code", null, "<Icon pattern=\"".concat(pattern, "\" type=\"coin\" />")))))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h3",
    gutterBottom: true
  }, "States"), /*#__PURE__*/React.createElement("div", {
    className: classes.iconsWrapper
  }, states.map(state => /*#__PURE__*/React.createElement("div", {
    className: classes.iconStateWrapper,
    key: state
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    state: state,
    type: "coin"
  }), /*#__PURE__*/React.createElement("pre", {
    className: "".concat(classes.codeSnippet, " ").concat(classes.codeSnippetInline)
  }, /*#__PURE__*/React.createElement("code", null, "<Icon state=\"".concat(state, "\" />")))))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h3",
    gutterBottom: true
  }, "Colors"), /*#__PURE__*/React.createElement("div", {
    className: classes.iconsWrapper
  }, colors.map(color => /*#__PURE__*/React.createElement("div", {
    className: classes.iconStateWrapper,
    key: color
  }, /*#__PURE__*/React.createElement(Icon, {
    color: color,
    fontSize: "large",
    type: "coin"
  }), /*#__PURE__*/React.createElement("pre", {
    className: "".concat(classes.codeSnippet, " ").concat(classes.codeSnippetInline)
  }, /*#__PURE__*/React.createElement("code", null, "<Icon color=\"".concat(color, "\" type=\"coin\" />")))))))));
}